import { CircleIcCheck, CircleTimes } from 'components/Icons';
import { AssemblyModalities, SurveyEventType } from 'helpers/enums/Assembleia';
import { getApis } from 'library/Apis';
import {
  ButtonThemes,
  Col,
  Modal,
  ModalSizes,
  QRCode,
  Row,
  useHTMLShare,
} from 'plataforma-fundacao-componentes';
import { ModalProps } from 'plataforma-fundacao-componentes/dist/components/modal/Modal';
import { useCallback, useMemo, useState } from 'react';
import styles from './styles.scss';
const { rootClassName } = styles;

interface QrCodeModalProps extends ModalProps {
  prefix: any;
  eventId: number;
  survey?: boolean;
  modality?: AssemblyModalities;
  onCancel: () => void;
  onConfirm: () => void;
}

export const QrCodeModal = (props: QrCodeModalProps) => {
  const [loading, setLoading] = useState<boolean>();

  const share = useHTMLShare();

  const handleClose = useCallback(() => {
    props.onClose && props.onClose(props.modalKey);
  }, [props]);

  const mapApplicationIdToEventType = (
    applicationId: AssemblyModalities | null
  ): SurveyEventType | null => {
    switch (applicationId) {
      case 'ONLINE':
        return SurveyEventType.ASSEMBLEIAS_DIGITAL;
      case 'OFFLINE':
        return SurveyEventType.ASSEMBLEIAS_PRESENCIAL;
      case 'HIBRIDO_PRESENCIAL_DIGITAL':
      case 'HIBRIDO_SIMULTANEO':
      case 'HIBRIDO_DIGITAL_AGENCIA':
        return SurveyEventType.ASSEMBLEIAS_SEMIPRESENCIAL;
      default:
        return null;
    }
  };

  const param = useMemo(() => {
    return `${mapApplicationIdToEventType(props.modality!)}/${props.eventId}`;
  }, [props.eventId, props.modality]);

  const encode = btoa(param);

  const invite = useMemo(() => {
    return (
      <Row>
        <Col className={`${rootClassName}-qrcode`} centralized>
          <QRCode
            text={
              props.survey
                ? `${getApis().links.pesquisa}/${encode}`
                : `ps=1;id=${props.eventId}`
            }
            size={250}
            button={false}
          />
        </Col>
        <Col className={`${rootClassName}-title`} centralized>
          <p>
            {props.survey
              ? (props.prefix as any).modals.qrCodeModal.text_survey
              : (props.prefix as any).modals.qrCodeModal.text}
          </p>
        </Col>
        <Col className={`${rootClassName}-eventid`} centralized>
          <p>{props.eventId}</p>
        </Col>
      </Row>
    );
  }, [props.survey, props.eventId, props.prefix, encode]);

  return (
    <Modal
      modalKey={props.modalKey}
      title={props.title}
      mobileOn={props.mobileOn}
      preventEscExit={props.preventEscExit || false}
      preventMaskExit={props.preventMaskExit || false}
      size={ModalSizes.Small}
      footer={[
        {
          theme: ButtonThemes.Secondary,
          leftIcon: <CircleTimes />,
          children: (props.prefix as any).modals.qrCodeModal.cancel,
          onClick: props.onCancel,
        },
        {
          theme: ButtonThemes.Primary,
          leftIcon: <CircleIcCheck />,
          children: (props.prefix as any).modals.qrCodeModal.confirm,
          disabled: loading,
          loading: loading,
          onClick: () => {
            setLoading(true);
            share
              .pdf(
                invite,
                `Sicredi Assembleias Evento ${props.eventId!}.pdf`,
                (canvas) => {
                  return {
                    pdfWidth: canvas.width * 1.5,
                    pdfHeight: canvas.height * 1.5,
                    imageX: (canvas.width * 1.5 - canvas.width) / 2,
                    imageY: (canvas.height * 1.5 - canvas.height) / 2,
                  };
                }
              )
              .finally(() => {
                setLoading(false);
                setTimeout(() => {
                  handleClose();
                }, 200);
              });
          },
        },
      ]}
      className={rootClassName}
      onClose={props.onClose}
    >
      {invite}
    </Modal>
  );
};
